type MediaGalleryAction =
	| { type: 'SET_ACTIVE_INDEX'; payload: number }
	| { type: 'SET_TRANSLATE_GALLERY_PERCENTAGE'; payload: number }
	| { type: 'SET_TRANSLATE_THUMBNAIL_PERCENTAGE'; payload: number }
	| { type: 'SET_THUMBNAIL_SLIDES'; payload: { prevSlide: number; nextSlide: number } }
	| { type: 'SET_THUMBNAIL_CAROUSEL_WIDTHS'; payload: { thumbnailCarouselWidth: number; thumbnailMaxScrollWidth: number } }
	| { type: 'SET_SLIDES_PER_VIEW'; payload: number }
	| { type: 'SET_THUMBNAIL_TRANSITION_SPEED'; payload: number };

export type MediaGalleryState = {
	activeIndex: number;
	translateGalleryPercentage: number;
	translateThumbnailPercentage: number;
	thumbnailSlides: {
		prevSlide: number;
		nextSlide: number;
	};
	thumbnailCarouselWidth: number;
	thumbnailMaxScrollWidth: number;
	slidesPerView: number;
	thumbnailTransitionSpeed: number;
};

export const INITIAL_MEDIA_GALLERY_STATE: MediaGalleryState = {
	activeIndex: 0,
	translateGalleryPercentage: 0,
	translateThumbnailPercentage: 0,
	thumbnailSlides: {
		prevSlide: 0,
		nextSlide: 2
	},
	thumbnailCarouselWidth: 0,
	thumbnailMaxScrollWidth: 0,
	slidesPerView: 0,
	thumbnailTransitionSpeed: 0
};

export function mediaGalleryReducer(state: MediaGalleryState, action: MediaGalleryAction): MediaGalleryState {
	switch (action.type) {
		case 'SET_ACTIVE_INDEX':
			return { ...state, activeIndex: action.payload };
		case 'SET_TRANSLATE_GALLERY_PERCENTAGE':
			return { ...state, translateGalleryPercentage: action.payload };
		case 'SET_TRANSLATE_THUMBNAIL_PERCENTAGE':
			return { ...state, translateThumbnailPercentage: action.payload };
		case 'SET_THUMBNAIL_SLIDES':
			return { ...state, thumbnailSlides: action.payload };
		case 'SET_THUMBNAIL_CAROUSEL_WIDTHS':
			return {
				...state,
				thumbnailCarouselWidth: action.payload.thumbnailCarouselWidth,
				thumbnailMaxScrollWidth: action.payload.thumbnailMaxScrollWidth
			};
		case 'SET_SLIDES_PER_VIEW':
			return { ...state, slidesPerView: action.payload };
		case 'SET_THUMBNAIL_TRANSITION_SPEED':
			return { ...state, thumbnailTransitionSpeed: action.payload };
		default:
			return state;
	}
}
